var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.18 277.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee3097;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #021ca2;\n      }\n\n      .cls-3 {\n        fill: #21f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.39,
    y: 42.4,
    width: 192.85,
    height: 192.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 268.57,
    cy: 103.17,
    rx: 10.61,
    ry: 9.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.63,77.68V0H0v277.66h277.63v-149.01h-18.77v130.24H18.77V18.77h240.08v58.91h18.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.77,138.46l-6.04,14.14h9.42v15.14c-1.91,1.09-4.22,1.88-6.88,2.38-2.66.5-5.41.75-8.26.75-4.91,0-9.42-.72-13.52-2.19-4.1-1.44-7.57-3.57-10.45-6.32-2.88-2.75-5.16-6.04-6.82-9.89-1.66-3.82-2.5-8.13-2.5-12.89,0-5.07.78-9.64,2.32-13.7,1.53-4.04,3.79-7.48,6.69-10.32,2.91-2.82,6.48-4.97,10.64-6.44,4.19-1.44,8.85-2.19,14.02-2.19,2.16,0,4.54.28,7.13.81,2.6.56,5.1,1.22,7.57,2,2.47.81,4.47,1.69,6.07,2.69l4.88-13.52c-3.41-1.91-7.48-3.5-12.2-4.76-4.72-1.25-9.82-1.88-15.33-1.88-6.26,0-12.2,1.06-17.83,3.13-5.63,2.1-10.57,5.19-14.89,9.32-4.29,4.13-7.73,9.23-10.26,15.27-2.53,6.07-3.82,13.01-3.82,20.84,0,6.51,1.13,12.45,3.38,17.83,2.25,5.38,5.47,10.07,9.64,14.02,4.19,3.97,9.2,7.07,15.08,9.32,5.88,2.25,12.55,3.38,19.96,3.38,2.6,0,5.38-.28,8.38-.88,3-.56,5.94-1.31,8.82-2.19,2.88-.88,5.41-1.88,7.63-3,2.22-1.13,3.97-2.22,5.32-3.32v-37.54h-18.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.5b950ed5f7bee9c66d7a56d0789e49e3.svg";
export { ForwardRef as ReactComponent };